import { assets } from "@/lib/assets"
import {ArrowRight} from 'lucide-react'

function GiftSet() {
  return (
    <section data-nav="dark" className="bg-[#f6f1e8] px-8 py-20 md:px-10 md:py-28">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="font-display text-[30px] tracking-[0.16em] text-slate-700 md:text-[38px]">
          A GIFT TO REMEMBER
        </h2>
        <p className="mt-3 text-[13px] tracking-[0.14em] text-slate-500">
          把一段氣味，變成一段記憶
        </p>

        <img
          src={assets.productSetMobile}
          alt="微光限定禮盒"
          className="mx-auto mt-12 w-full max-w-xl object-contain md:hidden"
        />
        <img
          src={assets.productSet}
          alt="微光限定禮盒"
          className="mx-auto mt-12 hidden w-full max-w-3xl object-contain md:block"
        />

        <p className="mt-10 font-serif-tc text-xl tracking-[0.16em] text-slate-700">
          微光限定禮盒
        </p>
        <p className="mt-1 font-display text-sm italic tracking-[0.12em] text-slate-400">
          Inner Light Gift Set
        </p>
        <p className="mt-4 font-display text-2xl text-slate-700">NT$ 1,680</p>

        <a
          href="#order"
          className="mt-8 inline-flex items-center gap-3 bg-[#2b4456] px-8 py-3 text-[12px] tracking-[0.28em] text-white transition hover:bg-[#1d3342]"
        >
          立即收藏
          <ArrowRight size={14} />
        </a>

      </div>
    </section>
  )
}

export default GiftSet
